import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ImpactNumbers from '../components/ImpactNumbers';
import DivisionBlock from '../components/DivisionBlock';
import About from '../components/About';
import Services from '../components/Services';
import Pricing from '../components/Pricing';
import WorksGallery from '../components/WorksGallery';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import CookieBanner from '../components/CookieBanner';
import { Toaster } from '../components/ui/toaster';
import { useSite } from '../context/SiteContext';
import { useLang } from '../context/LangContext';
import { Loader2 } from 'lucide-react';

const Home = () => {
  const { loading, error, content } = useSite();
  const { t } = useLang();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0d1b2a] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-[#00e0c7] animate-spin" />
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="min-h-screen bg-[#0d1b2a] flex items-center justify-center text-white/60 px-6 text-center">
        <div>
          <p className="text-lg mb-2">{t('common.error')}</p>
          <p className="text-sm text-white/40">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#0d1b2a] min-h-screen">
      <Header />
      <main>
        <Hero />
        <ImpactNumbers />
        <DivisionBlock />
        <About />
        <Services />
        <Pricing />
        <WorksGallery />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
      <Toaster />
    </div>
  );
};

export default Home;
